module.exports = __webpack_public_path__ + "img/status-uncomplete.svg";